import { useState } from 'react';
import { ComponentActionClient, ComponentActionDTO } from '../services/apiClient';
import { API_BASE_URL } from '../config/config';
import axiosInstance from '../services/axiosInstance';

export const useComponentActionApi = () => {
    const apiClient = new ComponentActionClient(API_BASE_URL, axiosInstance);

    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const create = async (data: ComponentActionDTO) => {
        setIsLoading(true);
        try {
            await apiClient.createComponentAction(data);
        } catch (err: any) {
            setError(err.message || 'Error creating ComponentAction');
        } finally {
            setIsLoading(false);
        }
    };

    const edit = async (id: string, data: ComponentActionDTO) => {
        setIsLoading(true);
        try {
            await apiClient.updateComponentAction(id, data);
        } catch (err: any) {
            setError(err.message || 'Error updating ComponentAction');
        } finally {
            setIsLoading(false);
        }
    };

    const getById = async (id: string) => {
        setIsLoading(true);
        try {
            return await apiClient.getComponentActionById(id);
        } catch (err: any) {
            setError(err.message || 'Error fetching ComponentAction');
        } finally {
            setIsLoading(false);
        }
    };

    const search = async (filters: any) => {
        setIsLoading(true);
        try {
            return await apiClient.searchComponentActions(filters);
        } catch (err: any) {
            setError(err.message || 'Error searching ComponentActions');
        } finally {
            setIsLoading(false);
        }
    };

    const remove = async (id: string) => {
        setIsLoading(true);
        try {
            await apiClient.deleteComponentAction(id);
        } catch (err: any) {
            setError(err.message || 'Error deleting ComponentAction');
        } finally {
            setIsLoading(false);
        }
    };

    return { create, edit, getById, search, remove, isLoading, error };
};